export class ActiveScoutCensusSummaryForm {
    public comment
    public stateAwards
    public ypsCitizenship
    public ypsResidence
    public ypsAccept
    public ypsKRKSent
    public krkIssueDate
    public assignments

    constructor({
        comment: comment,
        ypsCitizenship: ypsCitizenship,
        ypsResidence: ypsResidence,
        ypsAccept: ypsAccept,
        ypsKRKSent: ypsKRKSent,
        krkIssueDate: krkIssueDate,
        assignments: assignments, 
        stateAwards: stateAwards,
    }: {
        comment?: string,
        ypsCitizenship: string,
        ypsResidence: string,
        ypsAccept: boolean,
        ypsKRKSent: boolean,
        krkIssueDate: string,
        assignments: ScoutCensusSummaryActiveAssignmentsForm[],
        stateAwards: string,
    }) {
        this.comment = comment
        this.ypsCitizenship = ypsCitizenship
        this.ypsResidence = ypsResidence
        this.ypsAccept = ypsAccept
        this.ypsKRKSent = ypsKRKSent
        this.krkIssueDate = krkIssueDate
        this.assignments = assignments
        this.stateAwards = stateAwards
    }
}

export class ScoutCensusSummaryActiveAssignmentsForm {
    public isMain
    public assignedFunction
    public startDate
    public endDate
    public decree
    public additionalInformation
    public unit
    public unitName
    constructor({
        isMain: isMain,
        assignedFunction: assignedFunction,
        startDate: startDate,
        endDate: endDate,
        decree: decree, 
        additionalInformation: additionalInformation,
        unit: unitId,
        unitName: unitName,
    }: {
        isMain: boolean,
        assignedFunction: string,
        startDate: string,
        endDate: string,
        decree?: string,
        additionalInformation?: string
        unit: string
        unitName?: string
    }) {
        this.isMain = isMain
        this.assignedFunction = assignedFunction
        this.startDate = startDate
        this.endDate = endDate
        this.decree = decree
        this.additionalInformation = additionalInformation
        this.unit = unitId
        this.unitName = unitName
    }

    validate() {
        let dateParse: boolean;
        try {
            dateParse = new Date(this.startDate) > new Date(this.endDate);
        } catch(e){
            return false;
        }

        return typeof this.isMain === "boolean" && typeof this.assignedFunction === "string" && dateParse && typeof this.unit === "string" && !(this.decree && typeof this.decree !== "string");
    }
}
